
const ComparisonRow = ({ before, after, altBefore, altAfter }) => (
  <div className="ba-comparison-row">
    <div className="ba-comparison-item">
      <img 
        src={before}
        alt={altBefore}
        className="ba-comparison-image"
        loading="lazy"
      />
      <div className="ba-comparison-label ba-label-before">AVANT</div>
    </div>
    <div className="ba-comparison-item">
      <img 
        src={after}
        alt={altAfter}
        className="ba-comparison-image"
        loading="lazy"
      />
      <div className="ba-comparison-label ba-label-after">APRÈS</div>
    </div>
  </div>
);

export default ComparisonRow;
